/* Häufige Fragen – ehrliche, belegbare Antworten (von Thomas freigegeben 18.10.2026). Gemeinsame Quelle für UI (Faq.jsx) und FAQPage-Schema (Home). */
export const FAQ = [
  {
    q: "Was ist DIMEDIAL und wie funktioniert Robbie?",
    a: "DIMEDIAL macht Vereine und lokale Betriebe sichtbar. Robbie ist unser KI-Assistent: Du schickst ein Foto oder eine Sprachnachricht – in der Web-App oder per WhatsApp – und bekommst fertige Beiträge, Tickets, Website-Änderungen oder Newsletter zur Freigabe. Du gibst frei, Robbie erledigt den Rest.",
  },
  {
    q: "Für wen ist das gedacht?",
    a: "Für Vereine, Gastronomie, Einzelhandel, Handwerk, Hotels, Praxen und kleine Unternehmen – also alle, die lokal gefunden werden wollen, ohne viel Zeit für Marketing und Orga zu haben.",
  },
  {
    q: "Was kostet DIMEDIAL?",
    a: "Monatspakete gibt es ab 59 € netto pro Monat, monatlich kündbar. Ticketing hat 0 € Grundgebühr – nur eine kleine Gebühr je verkauftem Ticket. Studio-Aufträge (Film, Audio, Gestaltung) nach Festpreis. Alle Preise netto zzgl. MwSt.",
  },
  {
    q: "Kann ich kostenlos testen?",
    a: "Ja. 30 Tage alle Bausteine kostenlos, ohne Zahlungsdaten. Es verlängert sich nichts automatisch – danach entscheidest du bewusst für ein Paket oder lässt es.",
  },
  {
    q: "Brauche ich technische Vorkenntnisse oder muss ich etwas installieren?",
    a: "Nein. Das meiste läuft per WhatsApp oder in der Web-App im Browser. Du schickst Fotos oder sprichst kurz rein, prüfst die Vorschau und gibst frei – mehr nicht.",
  },
  {
    q: "Muss ich alle Leistungen nehmen oder kann ich einzelne wählen?",
    a: "Du wählst modular. Ein Chat, alles verbunden – jeder Baustein funktioniert auch allein. Nimm nur das, was du gerade brauchst, und ergänze später.",
  },
  {
    q: "Wie hilft mir das, besser gefunden zu werden?",
    a: "Wir halten dein Google-Unternehmensprofil aktuell, veröffentlichen regelmäßig Social-Media-Beiträge und sorgen für eine gepflegte Website. Das stärkt deine lokale Sichtbarkeit. Echte Zahlen zeigen wir auf unserer Referenzseite – Aufrufe stehen für Sichtbarkeit, sind aber keine garantierten Verkäufe.",
  },
  {
    q: "Wer steckt hinter DIMEDIAL und wie werde ich betreut?",
    a: "DIMEDIAL gibt es seit 2000 in Herford (Ostwestfalen-Lippe). Du wirst persönlich betreut – per WhatsApp, E-Mail oder Telefon. Made in Germany.",
  },
  {
    q: "Wie funktioniert Ticketing für Vereine?",
    a: "Du bekommst einen eigenen Shop-Link für Tickets und Saisonkarten, verkaufst online und lässt am Eingang per Smartphone-Scanner einchecken. 0 € Grundgebühr – es fällt nur eine kleine Gebühr je verkauftem Ticket an. Einrichtung in wenigen Minuten.",
  },
  {
    q: "Hilft DIMEDIAL meinem Restaurant bei Google und Social Media?",
    a: "Ja. Du fotografierst zum Beispiel dein Tagesgericht, Robbie macht daraus einen Social-Media-Beitrag und eine Google-Meldung zur Freigabe. Zusätzlich halten wir dein Google-Unternehmensprofil aktuell (Öffnungszeiten, Fotos, Bewertungen) – so wirst du lokal besser gefunden.",
  },
  {
    q: "Kann ich Schaufenster- oder Gastraum-Bildschirme per WhatsApp steuern?",
    a: "Ja. Mit Digital Signage bespielst du Bildschirme im Schaufenster, Gastraum oder in der Halle mit einer eigenen Playlist und änderst die Inhalte einfach per WhatsApp – ohne zusätzliche Technik vor Ort.",
  },
  {
    q: "Funktioniert das auch für meinen Laden im Einzelhandel?",
    a: "Ja. Neue Ware einmal fotografieren – daraus entstehen Social-Media-Beitrag, Schaufensterbildschirm und Google-Meldung. So bleibt dein Laden sichtbar, ohne täglichen Mehraufwand.",
  },
];
